import React, { Component } from 'react'
import connect from "react-redux/es/connect/connect";

import { List, Datagrid, FilterForm } from 'components/list'
import { TextField } from 'components/field'
import { ActionButton, EditButton } from 'components/button'

import * as urls from './urls'
import * as utils from './utils';
import { DateInput, SelectInput } from "../../components/input";
import { 
  crudUpdate as crudUpdateAction,
  crudGetList as crudGetListAction,
} from 'actions/dataActions';


export async function retryFailed(props) {
  const formDataRecord = new FormData();
  const { record } = props;
  formDataRecord.append('status', utils.NOTIFICATION_STATUS_RETRYING);
  formDataRecord.append('app_type', record['app_type']);
  formDataRecord.append('message_type', record['message_type']);
  formDataRecord.append('title', record['title']);
  formDataRecord.append('body', record['body']);
  formDataRecord.append('url', record['url']);
  formDataRecord.append('send_type', record['send_type']);
  formDataRecord.append('delivery_type', record['delivery_type']);
  if (record['delivery_time']) {
    formDataRecord.append('delivery_time', record['delivery_time']);
  }

  return props.crudUpdate(
    props.resource, 
    record.id, 
    formDataRecord, 
    {}, 
    urls.notificationEditBackendPath, 
    props.basePath
  );

  // return props.customFetch(props.initialValues);
}

const NotificationFilter = (props) => (
  <FilterForm name='news_filter' {...props} initialValues={ props.defaultSearchValue }>
    <DateInput source='delivery_time_start' isRequired={true} label='Delivery From'/>
    <DateInput source='delivery_time_end' isRequired={true} label='Delivery To'/>
    <SelectInput source='status' label='Status' choices={utils.NOTIFICATION_STATUS_DISPLAY_CHOICES}/>
  </FilterForm>
);

const NotificationEditButton = (props) => {
    if (
      props.record.status_display !== utils.NOTIFICATION_STATUS_NAME[utils.NOTIFICATION_STATUS_SUCCESS] 
      && props.record.status_display !== utils.NOTIFICATION_STATUS_NAME[utils.NOTIFICATION_STATUS_FAILED]
      && props.record.status_display !== utils.NOTIFICATION_STATUS_NAME[utils.NOTIFICATION_STATUS_SENDING]
      && props.record.status_display !== utils.NOTIFICATION_STATUS_NAME[utils.NOTIFICATION_STATUS_RETRYING]
    ) {
      return <EditButton {...props}/>;
    }
    if (
      props.record.status_display === utils.NOTIFICATION_STATUS_NAME[utils.NOTIFICATION_STATUS_FAILED]
    ) {
      return (
        <ActionButton 
          {...props}
          label="Retry"
          action={() => { return retryFailed(props); }}
        />
      );
    }
    return null;
};

const CustomTextField = (props) => {
  const { record } = props;

  record.custom_status_display = record.status_display || '-';
  if (
    record.status === utils.NOTIFICATION_STATUS_FAILED
  ) {
    record.custom_status_display = `${record.status_display} (${record.success_ratio || '-/-'})`;
  }

  return (
    <TextField 
      {...props}
    />
  )
};

class NotificationList extends Component {
  render() {
    let {initialValues} = this.props;
    let autoLoadData = false;
    if (initialValues) {
      autoLoadData = true;
    } else {
      initialValues = {};
    }

    return (
      <List 
        hasCreate={true}
        filterValues={initialValues}
        filters={<NotificationFilter defaultSearchValue={initialValues}/>}
        {...this.props}
        autoLoadData={autoLoadData}
      >
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" label="ID"/>
          <TextField source="message_type" label="Type" choices={utils.MESSAGE_TYPE_CHOICES}/>
          <TextField source="title" label="Title"/>
          <TextField source="delivery_time" label="Delivery Time"/>
          <TextField source="send_type" label="Target" choices={utils.SEND_TYPE_CHOICES}/>
          <TextField source="last_updated_by" label="Last Updated By"/>
          <CustomTextField source="custom_status_display" label="Status"/>
          <NotificationEditButton 
            linkTo={urls.notificationEditFrontendPath} 
            label="Edit"
            crudUpdate={this.props.crudUpdate}
            customFetch={this.props.customFetch}
            initialValues={initialValues}
          />
          <EditButton linkTo={urls.notificationDetailFrontendPath} label="Detail"/>
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    initialValues: state.admin.filter[utils.NotificationResourceName],
  }),
  {
    customFetch: (initialValues) => (
      crudGetListAction(
        utils.NotificationResourceName, 
        urls.notificationBackendPath,
        {
          ...initialValues,
        }
      )
    ),
    crudUpdate: crudUpdateAction,
  }
)(NotificationList);



// WEBPACK FOOTER //
// ./src/routes/notification/NotificationList.js